import React from "react";
import { ConsentManagementServiceType } from "../types";
import { ConsentAcceptanceType } from "shared/enums/ConsentAcceptanceType";
import { LoadThirdPartyScripts } from "../scripts";

function OneTrustConsent({ service }: { service: ConsentManagementServiceType }) {
  const updateConsent = service.updateConsent;
  const [canLoad, setCanLoad] = React.useState(false);
  const getCurrentPermissions = React.useCallback(() => {
    const permissions = typeof window.OnetrustActiveGroups === "string" ? window.OnetrustActiveGroups : "";
    return {
      necessary: permissions.includes("C0001"),
      analytical: permissions.includes("C0002"),
      functional: permissions.includes("C0003"),
      targeting: permissions.includes("C0004")
    };
  }, []);

  React.useEffect(() => {
    updateConsent(ConsentAcceptanceType.THIRD_PARTY, getCurrentPermissions());
    setCanLoad(true);
  }, [updateConsent, getCurrentPermissions]);

  React.useEffect(() => {
    function handlePermissionUpdate() {
      updateConsent(ConsentAcceptanceType.THIRD_PARTY, getCurrentPermissions());
    }
    window.addEventListener("OneTrustGroupsUpdated", handlePermissionUpdate);
    return () => {
      window.removeEventListener("OneTrustGroupsUpdated", handlePermissionUpdate);
    };
  }, [updateConsent, getCurrentPermissions]);

  // with GTM one trust has already loaded
  // add event handler for consent change
  // initialize consent cookie with values from one trust
  return canLoad ? <LoadThirdPartyScripts /> : null;
}

export default OneTrustConsent;
